module.exports = __webpack_public_path__ + "static/media/icone_carline.11446092.jpg";